import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'

export const getTextFromNumber = (
  count: number,
  locale: PageLocaleEnum,
  translationForOne: string,
  translationForMany: string,
  translationForSlavicResults2to4: string,
): string => {
  const mod10 = count % 10
  const mod100 = count % 100

  const isSlavic = [
    PageLocaleEnum.RUSSIAN,
    PageLocaleEnum.UKRAINIAN,
    PageLocaleEnum.CZECH,
    PageLocaleEnum.SLOVAK,
    PageLocaleEnum.SERBIAN,
    PageLocaleEnum.SLOVENIAN,
    PageLocaleEnum.POLISH,
  ].includes(locale)

  if (isSlavic) {
    if (count === 0) return `0 ${translationForMany}`
    if (mod100 >= 11 && mod100 <= 14) return `${count} ${translationForMany}`
    if (mod10 === 1) return `${count} ${translationForOne}`
    if (mod10 >= 2 && mod10 <= 4)
      return `${count} ${translationForSlavicResults2to4}`
    return `${count} ${translationForMany}`
  }

  const text = count === 1 ? translationForOne : translationForMany

  return `${count} ${text}`
}
